<script setup lang="ts">
import { ref } from 'vue'
import type { AgentTestsModel } from '@/services/http/httpResponses.ts'
import testsHttpService from '@/services/http/testsHttpService.ts'
import { Roles } from '@/constants.ts'
import { RouterLink } from 'vue-router'
import type { ButtonProps } from 'primevue/button'
import { BillStatuses } from '@raildev/shared-utils'
import type { BillStatus } from '@raildev/shared-utils'

definePage({
  meta: { allowedRoles: [Roles.Admin] },
})

const billStatuses = Object.entries(BillStatuses)
  .filter(([_, value]) => value != BillStatuses.None)
  .map(([label, value]) => ({ label, value }))

const tests = ref<AgentTestsModel[]>([])

const getStatus = (status: BillStatus | null) => {
  return billStatuses.find((s) => s.value == status)?.label ?? 'Не инициализирован'
}

const { tests: loaded } = await testsHttpService.getAgentTests()
tests.value = loaded
</script>

<template>
  <div class="flex flex-col gap-4 w-full">
    <DataTable ref="dt" :value="tests" dataKey="id">
      <Column header="Статус оплаты" style="min-width: 12rem">
        <template #body="slotProps">
          {{ getStatus(slotProps.data.paymentStatus) }}
        </template>
      </Column>
      <Column header="Дата создания" style="min-width: 12rem">
        <template #body="slotProps">
          {{ slotProps.data.startDateTime.toLocaleString('ru-RU') }}
        </template>
      </Column>
      <Column header="Дата окончания" style="min-width: 12rem">
        <template #body="slotProps">
          {{ slotProps.data.endDateTime?.toLocaleString('ru-RU') }}
        </template>
      </Column>
      <Column header="Кол-во завершенных вопросов" style="min-width: 12rem">
        <template #body="slotProps">
          {{ `${slotProps.data.completedQuestions} из ${slotProps.data.allQuestions}` }}
        </template>
      </Column>
      <Column header="Данные пользователя" style="min-width: 12rem">
        <template #body="slotProps">
          <p>{{ slotProps.data.user.name }}</p>
          <p v-if="slotProps.data.user.email != null">{{ slotProps.data.user.email }}</p>
          <p v-if="slotProps.data.user.phoneNumber != null">
            {{ slotProps.data.user.phoneNumber }}
          </p>
        </template>
      </Column>
      <Column header="Агентское вознаграждение" style="min-width: 12rem">
        <template #body="slotProps">
          {{ slotProps.data.agentReward != null ? `${slotProps.data.agentReward} KZT` : '' }}
        </template>
      </Column>
      <Column header="Аналитика" style="min-width: 12rem">
        <template #body="slotProps">
          <Button asChild severity="info" v-slot="buttonSlotProps">
            <RouterLink
              :to="`/test-analytics/${slotProps.data.id}`"
              :class="(buttonSlotProps as ButtonProps).class"
            >
              Открыть тест
            </RouterLink>
          </Button>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<style scoped></style>
